import configuration from "../config.json";
import reportService from "../shared/services/reportService";
import CookieService from "../shared/services/cookiesService";
import { downloadFile } from "../shared/services/download.service";
import { setLogout } from "./authActions";

const REQUEST_DOWNLOAD_UNIT_REPORT = "REQUEST_DOWNLOAD_UNIT_REPORT";
const RESPONSE_DOWNLOAD_UNIT_REPORT = "RESPONSE_DOWNLOAD_UNIT_REPORT";
const REQUEST_DOWNLOAD_UNIT_REPORT_FAILURE = "REQUEST_DOWNLOAD_UNIT_REPORT_FAILURE";
const CLEAR_DOWNLOAD_UNIT_REPORT = "CLEAR_DOWNLOAD_UNIT_REPORT";

const requestDownloadUnitReportAction = () => {
  return {
    type: REQUEST_DOWNLOAD_UNIT_REPORT,
  };
};

const responseDownloadUnitReportAction = () => {
  return {
    type: RESPONSE_DOWNLOAD_UNIT_REPORT,
  };
};

const requestDownloadUnitReportFailureAction = (errors) => {
  return {
    type: REQUEST_DOWNLOAD_UNIT_REPORT_FAILURE,
    errors,
  };
};

const downloadUnitReport = (report, car, format, options) => {
  return (dispatch) => {
    dispatch(requestDownloadUnitReportAction());

    reportService
      .downloadReport(report.id, options)
      .then((result) => {
        downloadFile(result.data, report, car, format, options);
        dispatch(responseDownloadUnitReportAction());
      })
      .catch((error) => {
        dispatch(requestDownloadUnitReportFailureAction());

        if (error.response && error.response.status === 401) {
          dispatch(setLogout());
        }
      });
  };
};

const clearDownloadUnitReportAction = () => {
  return {
    type: CLEAR_DOWNLOAD_UNIT_REPORT,
  };
};

const clearDownloadUnitReport = () => {
  return (dispatch) => {
    dispatch(clearDownloadUnitReportAction());
  };
};

export {
  downloadUnitReport,
  requestDownloadUnitReportAction,
  responseDownloadUnitReportAction,
  requestDownloadUnitReportFailureAction,
  clearDownloadUnitReport,
  clearDownloadUnitReportAction,
  REQUEST_DOWNLOAD_UNIT_REPORT,
  RESPONSE_DOWNLOAD_UNIT_REPORT,
  REQUEST_DOWNLOAD_UNIT_REPORT_FAILURE,
  CLEAR_DOWNLOAD_UNIT_REPORT,
};
